import { faBell } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge, Stack, Text, UnstyledButton } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { useNotifications } from '../contexts/NotificationContext'
import { COLORS } from '../utils/constants'
import classes from './css/TopMenu.module.css'

const NotificationBadge = () => {
  const { unreadCount } = useNotifications()
  const navigate = useNavigate()

  return (
    <UnstyledButton
      onClick={() => navigate('/dashboard/notifications')}
      style={{ position: 'relative' }}
      visibleFrom='sm'
    >
      <Stack gap={0}>
        <FontAwesomeIcon
          icon={faBell}
          className={classes.accountIcon}
          style={{ color: 'white' }}
          size='xl'
        />
        <Text
          visibleFrom='sm'
          style={{
            color: 'white',
            fontSize: 10,
            textAlign: 'center',
          }}
        >
          Notifications
        </Text>
        {unreadCount > 0 && (
          <Badge
            color={COLORS.HiddenGemzRed}
            size='xs'
            style={{
              border: '2px solid #16503A',
              position: 'absolute',
              top: 5,
              right: 8,
              minWidth: '18px',
              height: '18px',
              fontSize: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </Badge>
        )}
      </Stack>
    </UnstyledButton>
  )
}

export default NotificationBadge
